import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import { ThemeProvider } from "./contexts/ThemeContext";
import { ToastProvider } from "./contexts/ToastContext";
import DeployUpdatePrompt from "./components/DeployUpdatePrompt";
import Auth from "./components/auth.jsx";
import WorkspaceBootstrap from "./components/WorkspaceBootstrap.jsx";
import { RequireBrandOutlet } from "./components/brands/RequireBrand.jsx";
import Account from "./pages/account/index.jsx";
import Brand from "./pages/brand/index.jsx";
import Brands from "./pages/brands/index.jsx";
import Audiences from "./pages/audiences";
import AudienceDetail from "./pages/audience/index.jsx";
import Scripts from "./pages/scripts/index.jsx";
import Ideas from "./pages/ideas/index.jsx";
import Videos from "./pages/videos/index.jsx";
import Api from "./pages/api/index.jsx";
import Home from "./pages/home/index.jsx";
import Login from "./pages/auth/login";
import Register from "./pages/auth/register";
import ResetPasswordRequest from "./pages/auth/ResetPasswordRequest";
import ResetPasswordConfirm from "./pages/auth/ResetPasswordConfirm";
import Unsubscribe from "./pages/email/Unsubscribe";
import WelcomeRoutes from "./pages/welcome";

const LegacyAudiencesRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const suffix = pathname.replace(/^\/audiences\/?/, "");
  const target = suffix ? `/research/${suffix}` : "/research/";
  return <Navigate to={`${target}${search}${hash}`} replace />;
};

const App = (props) => (
  <ThemeProvider>
    <ToastProvider>
      <DeployUpdatePrompt />
      <Router>
        <Auth {...props}>
          {(authProps) => {
            if (!authProps.authenticated) {
              return (
                <Routes>
                  <Route path="/login/" element={<Login {...authProps} />} />
                  <Route
                    path="/register/"
                    element={<Register {...authProps} />}
                  />
                  <Route
                    path="/reset-password/"
                    element={<ResetPasswordRequest {...authProps} />}
                  />
                  <Route
                    path="/reset-password/confirm/"
                    element={<ResetPasswordConfirm {...authProps} />}
                  />
                  <Route path="/email-unsubscribe/" element={<Unsubscribe />} />
                  <Route path="*" element={<Navigate to="/login/" />} />
                </Routes>
              );
            }

            return (
              <>
                <WorkspaceBootstrap />
                <Routes>
                <Route
                  path="/brands/new/*"
                  element={<Navigate to="/brand/new/" replace />}
                />
                <Route path="/brand/*" element={<Brand {...authProps} />} />
                <Route path="/brands/" element={<Brands {...authProps} />} />
                <Route path="/account/*" element={<Account {...authProps} />} />
                <Route
                  path="/welcome/*"
                  element={<WelcomeRoutes {...authProps} />}
                />
                <Route path="/email-unsubscribe/" element={<Unsubscribe />} />
                <Route path="/" element={<Home {...authProps} />} />
                <Route
                  path="/research/*"
                  element={<Audiences {...authProps} />}
                />
                <Route path="/audiences/*" element={<LegacyAudiencesRedirect />} />
                <Route
                  path="/audience/:hash/*"
                  element={<AudienceDetail {...authProps} />}
                />
                <Route
                  element={
                    <RequireBrandOutlet currentUser={authProps.currentUser} />
                  }
                >
                  <Route path="/ideas/*" element={<Ideas {...authProps} />} />
                  <Route
                    path="/profile/*"
                    element={<Navigate to="/brand/profile/" replace />}
                  />
                  <Route
                    path="/settings/*"
                    element={<Navigate to="/brand/settings/" replace />}
                  />
                  <Route
                    path="/scripts/*"
                    element={<Scripts {...authProps} />}
                  />
                  <Route path="/videos/*" element={<Videos {...authProps} />} />
                  <Route path="/api/*" element={<Api {...authProps} />} />
                </Route>
                <Route path="/login/" element={<Navigate to="/" />} />
                <Route path="/register/" element={<Navigate to="/" />} />
                <Route
                  path="/results/*"
                  element={<Navigate to="/scripts/" replace />}
                />
                <Route path="/brands/*" element={<Navigate to="/brands/" replace />} />
                <Route path="*" element={<Navigate to="/ideas/" />} />
              </Routes>
              </>
            );
          }}
        </Auth>
      </Router>
    </ToastProvider>
  </ThemeProvider>
);

export default App;
